export const DASHBOARD_URL = '/'
export const DOCUMENTS_URL = '/documents'
export const MY_PLANTS_URL = '/plant-infos'
export const SELECT_PLANT_URL = '/plant-select'
export const DOWNLOAD_URL = '/download'
export const CGU_URL = '/cgu'

export const DOCUMENTATION_API = '/api-documentation'
export const USER_DOCUMENTATION = 'https://urbasolar.atlassian.net/l/cp/Q8ovd10J'

export const ACTIVES_URL = [
  DASHBOARD_URL,
  DOCUMENTS_URL,
  DOWNLOAD_URL,
  CGU_URL,
  MY_PLANTS_URL,
  DOCUMENTATION_API,
]
